import styled from "styled-components";
import { Color, Font, breakpoints , ColorDark} from "@/shared/Constants";

export const GridNewsToday = styled.div`
  border-bottom: 1px solid ${Color.greySeparator};
  height: 45px;
  background-color: ${Color.white};
  ${breakpoints.darkMode} {
      [data-theme='dark'] & {
        border-bottom: 1px solid ${ColorDark.greySeparator};
        background-color: ${ColorDark.darkGrey};
      }
    }
  div {
    display: flex;
  }
`;

export const ContentNewsToday = styled.ul`
  display: flex;
  align-items: center;
  touch-action: inherit;
  width: 100% !important;
  overflow-x: auto;
  overflow-y: hidden;
  height: 45px;
  li {
    margin-right: 12px;
    p.titleToday {
      width: max-content;
      align-items: center;
      display: flex;
      margin: 0;
      a {
        ${Font.sansRegular};
        font-size: 12px;
        color: ${Color.grey};
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
            color:${ColorDark.textLight};
          }
        }
      }
    }
    position: relative;
    &:first-child {
      padding-left: 8px;
    }
  }

  /* width */
  ::-webkit-scrollbar {
    width: 0px;
    height: 0;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: none;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: none;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: none;
  }
`;
export const DateToday = styled.li`
  display: none;
  ${breakpoints.mobileFirst} {
    display: flex;
    justify-content: center;
    ${Font.sansRegular};
    font-size: 12px;
    color: ${Color.grey};
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
          color:${ColorDark.grey};
      }
        }
    white-space: nowrap;
  }
`;
export const RightContent = styled.ul`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  height: 45px;
  margin-left: 15px;
`;

export const EditionSelect = styled.li`
  display: none;
  ${breakpoints.mobileFirst} {
    display: flex;
    justify-content: centert;
    margin-left: 15px;
    position: relative;
    height: 100%;
    top: 5px;
    z-index: 5;
    details {
      padding: 12px 10px;
      min-height: 5px;
      transition: all 0.3s;
      width: 145px;
      form {
        width: 125px;
        margin-top: 10px;
        ul {
          li {
            height: 40px;
            display: flex;
            align-items: center;
            cursor: pointer;
            input[type="radio"] {
              display: none;
              &:checked + label span svg {
                opacity: 1;
                fill: ${Color.mainColor};
              }
              &:checked + label {
                color: ${Color.mainColor};
              }
            }
            label {
              font-size: 12px;
              ${Font.sansBold};
              display: flex;
              align-items: center;
              color: ${Color.black000};
              flex-direction: row-reverse;
              justify-content: space-between;
              width: 100%;
              cursor: pointer;
              span {
                svg {
                  opacity: 0;
                  transition: all 0.3s ease;
                }
              }
            }

            &:first-child {
              border-top: 1px solid ${Color.greySeparator};
              border-bottom: 1px solid ${Color.greySeparator};
            }
          }
        }
      }
      summary {
        cursor: pointer;
        display: flex;
        font-size: 12px;
        ${Font.sansRegular};
        justify-content: space-between;
        color: ${Color.grey777};
        .close {
          display: none;
        }
      }
    }
    details[open] {
      min-height: 120px;
      background-color: #f1f1f1;
      summary {
        color: ${Color.black000};
        .selected,
        .chevronUp {
          display: none;
        }
        .close {
          display: block;
        }
      }
    }
  }
`;

export const Title = styled.span`
  align-items: center;
  display: flex;
  color: ${Color.grey};
  font-size: 12px;
  ${Font.sansBold};
  justify-content: center;
  letter-spacing: 0px;
  white-space: nowrap;
  margin-right: 2px;
  ${breakpoints.darkMode} {
    [data-theme='dark'] & {
          color:${ColorDark.textLight};
        }
      }
`;
